<template>
    <div class="c-visit-dates component">
        <span class="label mb--2">
            Na podstawie danych wprowadzonych przez Ciebie możemy zaoferować następujące wizyty. Kliknij  aby wybrać wizytę.
        </span>
        <div class="c-visit-dates__item flex-row pointer" v-for="(term,key) in getAvaibleTerms"  :class="{'c-visit-dates__item--best': key < 4}" v-if="key <= perpage*(page + 1)" v-on:click="chooseTerm(term,key)" :key="key">
            <div class="flex-col flex-col--3 pr--1 mr--2">
                <h3 class="c-visit-dates__suggestion text--upper mb--1" v-if="key < 4">Najlepszy</h3>
                <h3 class="c-visit-dates__suggestion text--upper mb--1" v-else>&nbsp;</h3>
                <small>
                    <br>
                    {{ getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(term.date)] }} {{ term.date }}
                    <br>
                    {{ term.hour }}
                </small>
            </div>
            <div class="flex-col flex-col--6 mt--1">
                <img src="@/assets/localizations.jpg" alt="Localization" class="c-visit-dates__icon">
                <h3>{{ getSelectedDealer.name }}</h3>
                <span class="c-visit-dates__person">Doradca serwisowy: {{ term.user_name }}</span>
            </div>
        </div>
        <button class="btn btn--primary" v-if="getAddmissionTerms.length > 0 && getAddmissionTerms.length >= perpage*page" v-on:click="page++">Pokaż kolejne</button>
    </div>
</template>
<script>
    import {mapGetters,mapActions} from 'vuex';

    import lead from '@/mixins/lead.js'

    export default {
        data(){
            return {
                page: 0,
                perpage:4
            }
        },
        computed:{
            ...mapGetters({
                getDealers:'definitions/getDealers',
                getAddmissionTerms:'definitions/getAddmissionTerms',
                getRepairTerms:'definitions/getRepairTerms',
                getAvaibleTerms:'definitions/getAvaibleTerms',
                getDetepickerConfig:'definitions/getDetepickerConfig'
            }),
            getSelectedDealer() { return this.getDealers.find( e => e.id == this.lead.dealer_id) }
        },
        mixins:[lead],
        methods:{
            ...mapActions({
                fetchServiceAdmissionTerms:'definitions/fetchServiceAdmissionTerms',
                fetchServiceRepairTerms:'definitions/fetchServiceRepairTerms',
                filterAvaibleTerms: 'definitions/filterAvaibleTerms'
            }),
            chooseTerm(term,key){
                this.lead.date = term.date; 
                this.lead.hour = term.hour;
                this.lead.advisor_id = term.user_id;
                this.lead.term_key = key;
                this.lead.repair = term.mechanic_term;
                this.lead.mechanic_id = term.mechanic_term.mechanic_id;
                this.lead.mechanic_hour = term.mechanic_term.hour;
                this.$router.push({ path: 'client' })
            }
        },
        mounted(){
            var request = {limit:4};

            Object.keys(this.lead).map( k => {
            if(['date_from','hour_from','hour_to','dealer_id'].includes(k)){
                request[k] = this.lead[k]
            }
            });

            this.fetchServiceAdmissionTerms(request);
            
        }
    }
</script>
<style lang="scss">
    .c-visit-dates{
        &__item{
            border-left: 5px solid $gray;
            padding-left: .5rem;
            margin-bottom: 2rem;
            .flex-col{
                position: relative;
                &:first-of-type::after{
                    content: ' ';
                    display: block;
                    background: $gray;
                    height: 96px;
                    width:0;
                    position: absolute;
                    top: -.5rem;
                    left: -1rem;
                    z-index: -1;
                    transition: width .25s linear;
                }
            }
            &:hover{
                & .flex-col:first-of-type{
                    color: $white;
                    .c-visit-dates__suggestion{
                        color: $white;
                    }
                    &::after{
                        width:calc(100% + 6rem);
                    }
                }
            }
            &--best{
                border-left: 5px solid $green;
                .flex-col{
                    &:first-of-type::after{
                        background: $green;
                    }
                }
                .c-visit-dates__suggestion{
                    color: $green;
                }
            }
        }

        &__suggestion{
            color: $darkgray;
            margin-top: -.5rem;
        }
        &__person{
            font-size: 1.25rem;
        }
        &__icon{
            width: 16px;
            float: left;
            image-rendering: pixelated;
            margin-top: .25rem;
            margin-right: .5rem;
        }
    }
</style>